import { render, staticRenderFns } from "./FeedItemMsg.vue?vue&type=template&id=1dbb0a0d&scoped=true&"
import script from "./FeedItemMsg.vue?vue&type=script&lang=js&"
export * from "./FeedItemMsg.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemMsg.vue?vue&type=style&index=0&id=1dbb0a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb0a0d",
  null
  
)

export default component.exports